import { Injectable } from '@angular/core';

declare const $: ((selector: string) => { addClass(c: string): unknown; removeClass(c: string): unknown }) | undefined;

@Injectable({ providedIn: 'root' })
export class SidebarService {
  isShown = false;

  init(): void {}

  toggle(): boolean {
    if (this.isShown) {
      return this.hide();
    }
    return this.show();
  }

  hide(): boolean {
    this.isShown = false;
    if (typeof $ !== 'undefined') {
      $('.main').removeClass('no-scroll');
    }
    return this.isShown;
  }

  show(): boolean {
    this.isShown = true;
    if (typeof $ !== 'undefined') {
      $('.main').addClass('no-scroll');
    }
    return this.isShown;
  }
}
